var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_item",on:{"click":function($event){return _vm.movePage()}}},[_c('img',{attrs:{"src":(_vm.image + "?v=1")}}),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }